import { render } from "./ManageKnowledge.vue?vue&type=template&id=a43e100a&scoped=true"
import script from "./ManageKnowledge.vue?vue&type=script&lang=js"
export * from "./ManageKnowledge.vue?vue&type=script&lang=js"

import "./ManageKnowledge.vue?vue&type=style&index=0&id=a43e100a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a43e100a"]])

export default __exports__